import { useCallback, useState } from "react";

export const useTableSortReset = () => {
  const [sortResetKey, setSortResetKey] = useState(0);

  const resetTableSort = useCallback(() => {
    setSortResetKey((key) => key + 1);
  }, []);

  return { sortResetKey, resetTableSort };
};
